// Shared visible-text normalizer for live titles, thoughts, and tool labels.
// Control characters become spaces so streamed model text cannot break layout.

export function normalizeVisibleText(
    value: string,
    preserveNewlines = false,
): string | null {
    const withoutControlCharacters = Array.from(value, (character) => {
        const codePoint = character.codePointAt(0) ?? 0;
        if (preserveNewlines && (character === '\n' || character === '\t')) {
            return character;
        }
        return codePoint <= 31 || codePoint === 127 ? ' ' : character;
    }).join('');
    const normalized = preserveNewlines
        ? withoutControlCharacters
              .replace(/[^\S\n]+/g, ' ')
              .replace(/\n{3,}/g, '\n\n')
              .trim()
        : withoutControlCharacters.replace(/\s+/g, ' ').trim();
    return normalized.length > 0 ? normalized : null;
}
